export function focusField(fieldRef) {
  fieldRef.current && fieldRef.current.focus();
}
